/**
 * Size measurements (Bust / Waist / Hips) above the size variant picker.
 * Uses CustomDB.SizeChart from size-chart-db.js (designer slug from product handle).
 */
(function () {
  var NA = 'N/A';

  function getChartRow(designer, size) {
    if (typeof CustomDB === 'undefined' || !CustomDB.SizeChart || !designer || !size) {
      return null;
    }

    var rows = CustomDB.SizeChart[designer];
    if (!rows || !rows.length) {
      return null;
    }

    var sizeStr = String(size);
    for (var i = 0; i < rows.length; i++) {
      var parts = rows[i].split('/');
      if (parts[0] === sizeStr) {
        return {
          bust: parts[1],
          waist: parts[2],
          hips: parts[3]
        };
      }
    }

    return null;
  }

  function setMeasurements(container, size) {
    var sizeEl = container.querySelector('#currentSizeMeasurement');
    var bustEl = container.querySelector('#bustCnt');
    var waistEl = container.querySelector('#waistCnt');
    var hipsEl = container.querySelector('#hipsCnt');

    if (!sizeEl || !bustEl || !waistEl || !hipsEl) {
      return;
    }

    if (size) {
      sizeEl.textContent = size;
    }

    var row = getChartRow(container.dataset.designer, sizeEl.textContent);

    if (row) {
      bustEl.textContent = row.bust;
      waistEl.textContent = row.waist;
      hipsEl.textContent = row.hips;
    } else {
      bustEl.textContent = NA;
      waistEl.textContent = NA;
      hipsEl.textContent = NA;
    }
  }

  function getSizeFromVariantDetail(container, detail) {
    if (!detail || !detail.currentlySelectedValues) {
      return null;
    }

    var sizeOptionKey = container.dataset.sizeOption;
    var match = detail.currentlySelectedValues.find(function (item) {
      return item.index === sizeOptionKey;
    });

    return match ? match.value : null;
  }

  function bindContainer(container) {
    setMeasurements(container, container.querySelector('#currentSizeMeasurement').textContent);

    var productSection = container.closest('[data-product-id]');
    if (!productSection) {
      return;
    }

    productSection.addEventListener('variantChange', function (evt) {
      var size = getSizeFromVariantDetail(container, evt.detail);
      if (size) {
        setMeasurements(container, size);
      }
    });
  }

  function init() {
    document.querySelectorAll('.size-measurements[data-designer]').forEach(function (container) {
      if (container.dataset.sizeMeasurementsBound === 'true') {
        return;
      }
      container.dataset.sizeMeasurementsBound = 'true';
      bindContainer(container);
    });
  }

  document.addEventListener('variant:change', function (evt) {
    document.querySelectorAll('.size-measurements[data-designer]').forEach(function (container) {
      var size = getSizeFromVariantDetail(container, evt.detail);
      if (size) {
        setMeasurements(container, size);
      }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
